import { combineReducers } from 'redux';
import { reducer as loadingState } from '../../components/hoc/Loading';
import authenticate from './authenticate';
import explore from './explore';
import merchants from './merchants';
import merchantsProductsPurchases from './merchants/products/purchases';
import merchantsProductsPurchasesInputs from './merchants/products/purchases/inputs';
import merchantsResourcesBooks from './merchants/resources/books';
import merchantsResourcesBooksInputs from './merchants/resources/books/inputs';
import merchantsServices from './merchants/services';
import users from './users';

export default combineReducers({
  authenticate,
  explore,
  merchants,
  merchantsProductsPurchases,
  merchantsProductsPurchasesInputs,
  merchantsResourcesBooks,
  merchantsResourcesBooksInputs,
  merchantsServices,
  users,
  loadingState,
});
